"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PosCode = exports.MODIFIER_CODES = exports.INSURANCE_COUPON_IDENTIFIER = exports.INSURANCE_CARD_STATUSES_SELECT_OPTIONS_CONFIG = exports.INSURANCE_CARD_STATUSES = exports.FEE_SCHEDULE_PLAN_TYPES = exports.FEE_SCHEDULE_LICENSE_TYPES = exports.CPT_CODE_SEPARATOR = void 0;
var _INSURANCE_CARD_STATU;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var INSURANCE_COUPON_IDENTIFIER = 'INSURANCE';
exports.INSURANCE_COUPON_IDENTIFIER = INSURANCE_COUPON_IDENTIFIER;
var INSURANCE_CARD_STATUSES = /*#__PURE__*/function (INSURANCE_CARD_STATUSES) {
  INSURANCE_CARD_STATUSES["ACTIVE"] = "active";
  INSURANCE_CARD_STATUSES["INELIGIBLE"] = "ineligible";
  INSURANCE_CARD_STATUSES["PENDING"] = "pending";
  INSURANCE_CARD_STATUSES["ELIGIBLE"] = "eligible";
  INSURANCE_CARD_STATUSES["OPTED_OUT"] = "opted-out";
  INSURANCE_CARD_STATUSES["MIGRATED"] = "migrated";
  return INSURANCE_CARD_STATUSES;
}({});
exports.INSURANCE_CARD_STATUSES = INSURANCE_CARD_STATUSES;
var INSURANCE_CARD_STATUSES_SELECT_OPTIONS_CONFIG = (_INSURANCE_CARD_STATU = {}, _defineProperty(_INSURANCE_CARD_STATU, INSURANCE_CARD_STATUSES.PENDING, {
  type: 'warning',
  text: 'Pending'
}), _defineProperty(_INSURANCE_CARD_STATU, INSURANCE_CARD_STATUSES.ELIGIBLE, {
  type: 'warning',
  text: 'Eligible',
  disabled: true
}), _defineProperty(_INSURANCE_CARD_STATU, INSURANCE_CARD_STATUSES.INELIGIBLE, {
  type: 'alert',
  text: 'Not eligible'
}), _defineProperty(_INSURANCE_CARD_STATU, INSURANCE_CARD_STATUSES.ACTIVE, {
  type: 'success',
  text: 'Active with insurance'
}), _defineProperty(_INSURANCE_CARD_STATU, INSURANCE_CARD_STATUSES.OPTED_OUT, {
  type: 'white',
  text: 'Opted out'
}), _defineProperty(_INSURANCE_CARD_STATU, INSURANCE_CARD_STATUSES.MIGRATED, {
  type: 'orange',
  text: 'Migrated',
  disabled: true
}), _INSURANCE_CARD_STATU);
exports.INSURANCE_CARD_STATUSES_SELECT_OPTIONS_CONFIG = INSURANCE_CARD_STATUSES_SELECT_OPTIONS_CONFIG;
var FEE_SCHEDULE_LICENSE_TYPES = ['LCSW', 'LPC', 'LMHC', 'LMFT', 'MD', 'DO'];
exports.FEE_SCHEDULE_LICENSE_TYPES = FEE_SCHEDULE_LICENSE_TYPES;
var FEE_SCHEDULE_PLAN_TYPES = ['CI', 'MB', 'MC', 'OF', 'HM', 'PCS', 'BL'];
exports.FEE_SCHEDULE_PLAN_TYPES = FEE_SCHEDULE_PLAN_TYPES;
var CPT_CODE_SEPARATOR = '|';
exports.CPT_CODE_SEPARATOR = CPT_CODE_SEPARATOR;
var MODIFIER_CODES = {
  // Top codes most commonly used by Operations
  CodeGT: 'GT',
  Code95: '95',
  Code25: '25',
  // Other codes
  Code22: '22',
  Code23: '23',
  Code24: '24',
  Code26: '26',
  Code27: '27',
  Code32: '32',
  Code33: '33',
  Code47: '47',
  Code50: '50',
  Code51: '51',
  Code52: '52',
  Code53: '53',
  Code54: '54',
  Code55: '55',
  Code56: '56',
  Code57: '57',
  Code58: '58',
  Code59: '59',
  Code62: '62',
  Code63: '63',
  Code66: '66',
  Code76: '76',
  Code77: '77',
  Code78: '78',
  Code79: '79',
  Code80: '80',
  Code81: '81',
  Code82: '82',
  Code90: '90',
  Code91: '91',
  Code92: '92',
  Code96: '96',
  Code97: '97',
  Code99: '99',
  CodeAF: 'AF',
  CodeAG: 'AG',
  CodeAK: 'AK',
  CodeAQ: 'AQ',
  CodeAS: 'AS',
  CodeCR: 'CR',
  CodeCS: 'CS',
  CodeCO: 'CO',
  CodeCQ: 'CQ',
  CodeEP: 'EP',
  CodeET: 'ET',
  CodeFP: 'FP',
  CodeG0: 'G0',
  CodeGA: 'GA',
  CodeGC: 'GC',
  CodeGE: 'GE',
  CodeGF: 'GF',
  CodeGJ: 'GJ',
  CodeGN: 'GN',
  CodeGO: 'GO',
  CodeGP: 'GP',
  CodeGQ: 'GQ',
  CodeGR: 'GR',
  CodeGV: 'GV',
  CodeGW: 'GW',
  CodeHA: 'HA',
  CodeHB: 'HB',
  CodeHC: 'HC',
  CodeHD: 'HD',
  CodeHG: 'HG',
  CodeHU: 'HU',
  CodeKX: 'KX',
  CodeLT: 'LT',
  CodeNU: 'NU',
  CodePD: 'PD',
  CodeQ0: 'Q0',
  CodeQ1: 'Q1',
  CodeQ5: 'Q5',
  CodeQ6: 'Q6',
  CodeQJ: 'QJ',
  CodeQW: 'QW',
  CodeRR: 'RR',
  CodeRT: 'RT',
  CodeTC: 'TC',
  CodeTF: 'TF',
  CodeTH: 'TH',
  CodeU1: 'U1',
  CodeUA: 'UA',
  CodeUB: 'UB',
  CodeSL: 'SL',
  CodeSA: 'SA'
};
exports.MODIFIER_CODES = MODIFIER_CODES;
var PosCode = {
  Home: '10',
  NotHome: '02'
};
exports.PosCode = PosCode;